import AppBannerImpl from './app-banner.jsx';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

export default UIView('AppBanner', AppBannerImpl);
